//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { PojoMap } from 'pojo-maps';

import { Like2BuyModerationStatus } from '@instagram-account/redux/like2buy/like2buyModerationModel';
import Cuid from '@models/Cuid';
import { IRightsPermissions } from '@models/IItemMetadata';
import { IMlsMediaItem } from '@models/IMlsMediaItem';
import { isDefined } from '@utils/filterPredicates';

export const getLike2BuyModerationStatus = (
  item: IMlsMediaItem,
  hasRights?: boolean,
): Like2BuyModerationStatus | typeof RIGHTS_NEEDED | undefined => {
  if (item.like2buyMetadata?.isHidden) {
    return Like2BuyModerationStatus.Hidden;
  } else if (needsProducts(item)) {
    return Like2BuyModerationStatus.NeedsProducts;
    // TODO: Update when rights access is updated. MLS will
    // return true for isPublished so this needs to come before that check
  } else if (isDefined(hasRights) && !hasRights) {
    return RIGHTS_NEEDED;
  } else if (isDefined(item.like2buyMetadata?.pinnedPosition)) {
    return Like2BuyModerationStatus.Pinned;
  } else if (item.like2buyMetadata?.isPublished) {
    return Like2BuyModerationStatus.Published;
  }
};

export const RIGHTS_NEEDED = 'Rights Needed';

export const needsProducts = (item: IMlsMediaItem) => {
  return (item.productTags?.length ?? 0) == 0;
};

const REQUIRED_LIKE2BUY_DISTRIBUTION_CHANNEL = 'Social';

/**
 * Checks if a specified cuid has the 'Social' rights permission distribution channel
 * which is what is used in the Tributary Deets search query to find published items
 * to a Like2Buy gallery
 *
 * @param rightsPermissionsByCuid
 * @param cuid
 */
export const getHasRightsByCuid = (
  rightsPermissionsByCuid: PojoMap<Cuid, IRightsPermissions>,
  cuid: Cuid,
) => {
  return PojoMap.get(
    rightsPermissionsByCuid,
    cuid,
  )?.distributionChannels?.includes(REQUIRED_LIKE2BUY_DISTRIBUTION_CHANNEL);
};
